import { errorToast, toast } from "./toast"

const share = () => {

    const shareFuncs = {
        "data-share-button": async (data) => {
            try {
                await navigator.share({
                    text: data.text,
                    url: data.url
                })
            } catch (_) {}
        },
        "data-twitter-share-button": async (data) => {
          window.open(`https://twitter.com/intent/post?text=${encodeURIComponent(data.text)}&url=${encodeURIComponent(data.url)}`, '_blank', 'noopener,noreferrer')
        }
    }

    let canShare = false
    try {
        canShare = navigator.canShare({text: 'Test', url: 'https://test.com'})
    } catch (err) {}

    if (!canShare) document.querySelectorAll("[data-share-button]").forEach((el) => el.remove())

    Object.entries(shareFuncs).forEach(([key, func]) => {
        document.querySelectorAll(`[${key}]`).forEach((el) => {
            const text = el.getAttribute("data-share-text")
            const url = el.getAttribute("data-share-url")
            el.addEventListener("click", () => func({text, url}))
        })
    })

    document.querySelectorAll("[data-copy-button]").forEach((el) => {
        const text = el.getAttribute("data-copy-button")
        const msg = el.getAttribute("data-copy-message") ?? "Copied text"
        el.addEventListener("click", async () => {
            try {
                await navigator.clipboard.writeText(text)
                toast(msg)
            } catch (err) {
                errorToast("Error copying text")
            }
        })
    })
}

export default share
